import {Style} from "ol/style";
import {LayerControl} from "../controls/LayerControl";
import {EpLayer} from "./layer";
import {Heatmap} from "ol/layer";

export class EpHeatmap extends EpLayer {
    getLayer() {
        if (!this.style) {
            this.style = new Style();
        }

        if (!this.layer) {
            let visible = (LayerControl.getLayerSavedVisibility(this.name) ?? this.defaultVisibility) === 'true';

            this.layer = new Heatmap({
                source: this.getSource(),
                style: this.style,
                weight: function(feature) {
                    return feature.get('weight');
                },
                visible
            });
        }

        return this.layer;
    }
}
